import axios from "axios"
export const fetchData = async (pgSize) => {
    try {
        const response = await axios.get(`https://getinvoice.netlify.app/.netlify/functions/invoice?pageNumber=1&pageSize=${pgSize}`);
        return response.data;
    } catch (e) {
        console.log(e);
    }
}